import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CreateGallery() {
    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div class="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="subheader" class="text-dark">

                </section>

                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div class="container">
                        <div class="row wow fadeIn">
                            <div class="col-lg-3 col-sm-6 col-xs-12">


                                <h5>Preview</h5>
                                <div class="nft__item">
                                    <div class="author_list_pp">
                                    </div>
                                    <div class="nft__item_wrap">
                                        <p>Upload file to preview the banner of your gallery</p>
                                    </div>
                                    <div class="nft__item_info">

                                        <div class="nft__item_click">
                                        </div>
                                        <div class="nft__item_price">
                                        </div>
                                        <div class="nft__item_action">
                                        </div>
                                        <div class="nft__item_like">
                                        </div>
                                    </div>

                                </div>

                                {/*<!--uploaded-->
                            <!--<h5>Preview item</h5>
                            <div class="nft__item">
                                <div class="author_list_pp">
                                    <a href="#">                                    
                                        <img class="lazy" src="images/author/author-1.jpg" alt="">
                                        <i class="fa fa-check"></i>
                                    </a>
                                </div>
                                <div class="nft__item_wrap">
                                    <a href="#">
                                        <img src="images/collections/coll-item-3.jpg" id="get_file_2" class="lazy nft__item_preview" alt="">
                                    </a>
                                </div>
                                <div class="nft__item_info">
                                    <a href="#">
                                        <h4>Pinky Ocean</h4>
                                    </a>
                                    <div class="nft__item_click">
                                    <span></span>
                                </div>
                                <div class="nft__item_price">
                                        0.08 TON<span>1/20</span>
                                    </div>
                                    <div class="nft__item_action">
                                        <a href="#">Buy now </a>
                                    </div>
                                    <div class="nft__item_like">
                                        <i class="fa fa-heart"></i><span>50</span>
                                    </div>                            
                                </div> 
                            </div>-->
                            */}
                            </div>
                            <div class="col-lg-7 offset-lg-1">
                                
                                <h1 class="pb-30 title-mt">Create Gallery</h1>
                                <form id="form-create-item" class="form-border" method="post" action="email.php">
                                    <div class="field-set">
                                        <h5>Upload cover</h5>

                                        <div class="d-create-file">
                                            <p id="file_name">PNG, JPG, GIF, WEBP. Max 5mb.</p>
                                            <input type="button" id="get_file" class="btn-main" value="Browse" />
                                            <input type="file" id="upload_file" />
                                        </div>

                                        {/*
                                    <!--<div class="spacer-40"></div>

                                    <h5>Upload collection avatar</h5>

                                    <div class="d-create-file" style="width: 50%;">
                                        <p id="file_name">JPG, PNG, SVG, GIF and WEBP
                                            Size: 512×512px. Max 5mb.</p>
                                        <input type="button" id="get_file" class="btn-main" value="Browse">
                                        <input type="file" id="upload_file">
                                    </div>-->*/}


                                        <div class="spacer-40"></div>

                                        <h5>Name</h5>
                                        <input type="text" name="item_title" id="item_title" class="form-control" placeholder="e.g. 'Crypto Funk" />

                                        <div class="spacer-20"></div>

                                        <h5>Description <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional)</span></h5>
                                        <textarea data-autoresize name="item_desc" id="item_desc" class="form-control" placeholder="e.g. 'Describe what the idea is, how the NFT was created, or why people should buy it.'"></textarea>

                                        <div class="spacer-20"></div>
                                        {/*<!--<div class="alert alert-secondary" role="alert">
                                        <b><span aria-hidden="true" class="icon_info"></span> It will be impossible the alter the NFT data.</b>
                                        <p class="p-info">Editing NFTs is currently unavailable, so it will not be possible to change any data after minting.
                                        </p>
                                    </div>-->*/}
                                        <a href="/gallery" id="submit" class="btn btn-main" value="Create Gallery">Create Gallery</a>


                                    </div>
                                </form>
                            </div>


                        </div>
                    </div>
                </section>

            </div>

            {/* Footer component */}
            <Footer />

        </div>
    );
}

export default CreateGallery;